import { useState } from "react";
import { tg } from "../telegram";
import { useT } from "../i18n";
import Users from "./Users";
import NormsPanel from "./NormsPanel";
import SystemPanel from "./SystemPanel";
import { ScadaV2DataTab } from "./ScadaV2Panel";
import { AutoDataTab } from "./Automatika";
import UploadCard, { AlarmsSummary } from "../components/UploadCard";

type Sub = "data" | "users" | "norms" | "system";
type Src = "units" | "pa" | "alarms";

// «Управление» (admin only): uploads with a preview + import history for every
// source in one place, the users / invites page, the station norms (thresholds)
// and the state of the server, database and backups (step 5).
export default function AdminPanel() {
  const { t } = useT();
  const [sub, setSub] = useState<Sub>("data");
  const [unit, setUnit] = useState(1);
  const [src, setSrc] = useState<Src>("units");
  const [rev, setRev] = useState(0);   // bumped after an upload → the history below reloads
  const [err, setErr] = useState<string | null>(null);
  const subs: { k: Sub; label: string }[] = [
    { k: "data", label: t("admin.sub_data") }, { k: "users", label: t("tabs.users") },
    { k: "norms", label: t("admin.sub_norms") }, { k: "system", label: t("admin.sub_system") },
  ];
  const sources: [Src, number, string][] = [["units", 1, "G1"], ["units", 2, "G2"], ["pa", 1, t("telemetry.src_pa")], ["alarms", 0, t("up.src_alarms")]];
  return (
    <div>
      <h1>{t("tabs.admin")}</h1>
      <div className="period-tabs" style={{ marginBottom: 12 }}>
        {subs.map(s => (
          // four sub-tabs: a slimmer side padding keeps the Russian labels on a 375 px phone without scrolling
          <button key={s.k} className={"period-tab" + (sub === s.k ? " active" : "")} style={{ paddingLeft: 10, paddingRight: 10 }}
            onClick={() => { tg()?.HapticFeedback?.selectionChanged?.(); setSub(s.k); }}>{s.label}</button>
        ))}
      </div>
      {sub === "users" && <Users embedded />}
      {sub === "norms" && <NormsPanel />}
      {sub === "system" && <SystemPanel />}
      {sub === "data" && (
        <>
          <div className="turbine-switcher">
            {sources.map(([s, u, label]) => {
              const active = src === s && (s !== "units" || unit === u);
              return (
                <button key={label} className={"turbine-chip" + (active ? " active" : "")}
                  onClick={() => { tg()?.HapticFeedback?.selectionChanged?.(); setSrc(s); if (s === "units") setUnit(u); setErr(null); }}>
                  <span className="turbine-chip-name">{label}</span>
                </button>
              );
            })}
          </div>
          <div style={{ fontSize: 11.5, color: "var(--hint)", margin: "-4px 2px 10px" }}>{t("up.src_hint")}</div>
          {err && <div className="alert error">{err}</div>}
          <UploadCard unitHint={src === "units" ? unit : null} onDone={() => setRev(r => r + 1)} />
          {src === "units" && <ScadaV2DataTab key={`${unit}-${rev}`} unit={unit} qs={`unit=${unit}`} onErr={setErr} mode="history" />}
          {src === "pa" && <AutoDataTab key={`pa-${rev}`} unit={1} qs="unit=1" onErr={setErr} mode="history" />}
          {src === "alarms" && <AlarmsSummary key={`al-${rev}`} />}
        </>
      )}
    </div>
  );
}
